(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/date/date.tpl.html', [
'<div class="input-daterange input-group" ng-show="date.option.value==\'custom\'">',
'  <input type="text" class="form-control" name="start" ng-model="date.model.start" />',
'  <span class="input-group-addon">{{ \'date.to\' | translate }}</span>',
'  <input type="text" class="form-control" name="end"  ng-model="date.model.end"/>',
'</div>',
'<select class="form-control" ng-class="{ \'custom\' : date.option.value==\'custom\'}"',
'  ng-model="date.option" ng-change="date.change()"',
'  ng-options="option as option.label | translate for option in date.options track by option.value">',
'</select>',
'',''].join("\n"));
  }]);
})();